import {
    Button,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";

export default function OverLayButton({ toolTip, onClick, icon }) {
    return <OverlayTrigger
        overlay={
            <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
            >
                {toolTip}
            </Tooltip>
        }
    >
        <Button
            variant="secondary"
            onClick={onClick}
        >
            {icon && icon}
        </Button>
    </OverlayTrigger>
}